import React, { useEffect } from "react";
import SEO from "../components/SEO";
import "./About.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { FaEye, FaRocket } from "react-icons/fa";

import missionImg from "../assets/kids4.jpeg";
import visionImg from "../assets/vision.jpeg";
import aboutWhoImg from "../assets/gallery7.jpeg";


function About() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      easing: "ease-in-out",
      offset: 100,
    });

    AOS.refresh();
  }, []);

  return (
    <>
    <SEO
      title="About SIP Abacus Malkajgiri | Our Mission, Vision & Story"
      description="Learn about SIP Abacus Malkajgiri – a trusted abacus learning institute empowering children since 1999. Discover our mission, vision, and commitment to brain development, memory improvement & confidence building for kids in Hyderabad."
      keywords="about SIP Abacus Malkajgiri, SIP Academy history, abacus institute Malkajgiri, SIP Abacus mission, SIP Abacus vision, brain development training Hyderabad, trusted abacus classes, SIP Academy India, abacus education for children, kids learning centre Malkajgiri, abacus training since 1999, mental arithmetic institute Hyderabad, confidence building for kids, best abacus academy Hyderabad, who we are SIP Abacus"
      canonicalPath="/about"
    />
    <section className="about-page">
      <div className="container">
        {/* Hero Section */}
        <div className="about-hero" data-aos="fade-up">
          <span className="about-badge">Welcome to SIP Abacus Malkajgiri</span>
          <h1 className="about-title">
            Shaping Young Minds with the Power of Abacus
          </h1>
          <p className="about-description">
            At SIP Abacus Malkajgiri, we believe learning should be joyful,
            meaningful, and life changing. Our programs are carefully designed
            to strengthen arithmetic skills while enhancing concentration,
            memory, confidence, and overall brain development in children.
          </p>
        </div>

        {/* Who We Are Section */}
        <div className="who-we-are">
          <div className="who-left" data-aos="fade-right">
            <span className="who-tag">About SIP Abacus Malkajgiri</span>
            <h2>Who We Are</h2>

            <p>
              SIP Abacus Malkajgiri is a part of <strong>SIP Academy India</strong>{" "}
              and has been empowering children through structured brain
              development training for over two decades. Originating in Malaysia
              in 1999 and introduced in India in 2010, the program was built
              with a vision to nurture confident and capable young learners.
            </p>

            <p>
              Today, SIP Abacus Malkajgiri has grown into a trusted learning
              network across India, supported by schools, teachers, and parents.
              Our classrooms both offline and online are designed to be
              interactive and encouraging, where children not only learn faster
              calculations but also develop confidence, discipline, and a love
              for learning.
            </p>
          </div>

          <div className="who-right" data-aos="fade-left">
            <div className="who-visual-card">
              <div className="who-image-wrap">
                <img src={aboutWhoImg} alt="SIP Abacus classroom" />
              </div>
            </div>
          </div>
        </div>

        {/* Mission & Vision Section */}
        <div className="mission-vision-section">
          <div className="mission-card premium-card" data-aos="fade-up">
            <div className="mission-vision-image" data-aos="fade-right">
              <img src={missionImg} alt="SIP Abacus Mission" />
            </div>

            <div
              className="mission-vision-content"
              data-aos="fade-left"
              data-aos-delay="150"
            >
              <span className="mv-tag">Our Mission</span>
              <h2>
                <FaRocket className="mv-heading-icon" />
                Building Strong Foundations for Lifelong Learning
              </h2>

              <p>
                Our mission is to make learning meaningful, engaging, and
                effective for every child. Through structured abacus training,
                we aim to strengthen core skills such as concentration, memory,
                listening, and visualization in a fun and interactive way.
              </p>

              <div className="mv-points">
                <div className="mv-point" data-aos="fade-up" data-aos-delay="100">
                  Joyful and engaging learning
                </div>
                <div className="mv-point" data-aos="fade-up" data-aos-delay="200">
                  Stronger memory and focus
                </div>
                <div className="mv-point" data-aos="fade-up" data-aos-delay="300">
                  Confidence beyond academics
                </div>
              </div>
            </div>
          </div>

          <div className="vision-card premium-card reverse-card" data-aos="fade-up">
            <div className="mission-vision-image" data-aos="fade-left">
              <img src={visionImg} alt="SIP Abacus Vision" />
            </div>

            <div
              className="mission-vision-content"
              data-aos="fade-right"
              data-aos-delay="150"
            >
              <span className="mv-tag">Our Vision</span>
              <h2>
                <FaEye className="mv-heading-icon" />
                Inspiring Confident Thinkers for Tomorrow
              </h2>

              <p>
                Our vision is to create a generation of children who are not
                only strong in mathematics but also confident, creative, and
                focused individuals ready to take on future challenges.
              </p>

              <p>
                We strive to empower young minds with the ability to think
                independently, learn efficiently, and approach problems with
                clarity, confidence, and speed.
              </p>

              <div className="mv-points">
                <div className="mv-point" data-aos="fade-up" data-aos-delay="100">
                  Future ready learners
                </div>
                <div className="mv-point" data-aos="fade-up" data-aos-delay="200">
                  Balanced brain development
                </div>
                <div className="mv-point" data-aos="fade-up" data-aos-delay="300">
                  Sharp thinking with confidence
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Why SIP Section */}
        <div className="about-highlight" data-aos="fade-up">
          <div className="about-highlight-badge">Why Choose Us</div>
          <h2>Why SIP Abacus Malkajgiri Stands Out</h2>

          <p>
            SIP Abacus Malkajgiri offers a well balanced approach that combines
            structured learning with an engaging environment. Instead of
            memorizing answers, children develop the ability to think,
            visualize, and solve problems with confidence and clarity.
          </p>

          <div className="about-highlight-points">
            <div className="highlight-point" data-aos="zoom-in" data-aos-delay="100">
              Structured and engaging curriculum
            </div>
            <div className="highlight-point" data-aos="zoom-in" data-aos-delay="200">
              Focus on confidence and personality development
            </div>
            <div className="highlight-point" data-aos="zoom-in" data-aos-delay="300">
              Improved speed, accuracy, and concentration
            </div>
          </div>
        </div>
      </div>
    </section>
    </>
  );
}

export default About;